<div class="nda-container" *ngIf="state || isLoading">
  <div class="wrapper">
    <div class="logo">
      <img
        [src]="companyLogo()"
        [alt]="companyName"
        width="42px"
        loading="lazy"
      />
    </div>
    <div class="body">
      <div class="subject" *ngIf="isLoading">
        Loading NDA signature request...
        <span>
          <i class="pi pi-spin pi-spinner loading"></i>
        </span>
      </div>

      <div class="subject" *ngIf="state">
        <ng-container *ngIf="!requestedByCurrentUser; else userRequestedBlock">
          <span class="company-name" (click)="companyClick($event)"
            >{{ companyName }}
          </span>
          <ng-container *ngIf="!state.completed && !state.pendingOtherParty">
            has sent a request for you to sign an NDA</ng-container
          >
          <ng-container *ngIf="state.completed"
            >request for NDA signing is completed.</ng-container
          >
          <ng-container *ngIf="state.pendingOtherParty"
            >signature for the NDA is pending.</ng-container
          >
        </ng-container>

        <ng-template #userRequestedBlock>
          <ng-container *ngIf="!state.completed && !state.pendingOtherParty">
            You have requested an NDA with
            <span class="company-name" (click)="companyClick($event)"
              >{{ companyName }}
            </span>
          </ng-container>
          <ng-container *ngIf="state.completed">
            <span class="company-name" (click)="companyClick($event)"
              >{{ companyName }}
            </span>
            request for NDA signing is completed.</ng-container
          >
          <ng-container *ngIf="state.pendingOtherParty"
            ><span class="company-name" (click)="companyClick($event)"
              >{{ companyName }}
            </span>
            signature for the NDA is pending.</ng-container
          >
        </ng-template>
      </div>

      <div class="actions" *ngIf="state">
        <ng-container *ngIf="!state.completed && !state.pendingOtherParty">
          <s-button
            type="secondary"
            skin="red"
            size="small"
            icon="pi pi-times-circle"
            iconPos="left"
            [label]="'Decline'"
            (click)="onDeclineNdaClick()"
          ></s-button>
          <s-button
            type="primary"
            skin="green"
            size="small"
            iconPos="left"
            [label]="'Sign NDA'"
            [icon]="
              isButtonDisabled ? 'pi pi-spin pi-spinner' : 'pi pi-check-circle'
            "
            [disabled]="isButtonDisabled"
            (click)="onSignNdaClick()"
          ></s-button>
        </ng-container>
        <ng-container *ngIf="state.pendingOtherParty">
          <s-button
            type="primary"
            size="small"
            iconPos="left"
            [label]="'Pending'"
            [icon]="'pi pi-clock'"
            [disabled]="true"
          ></s-button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  styleClass="delete-dialog"
  [baseZIndex]="10000"
  [closable]="true"
  key="sign-nda"
></p-confirmDialog>
